import { useContext, useState } from 'react'
import { Button, Menu, MenuItem } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons'

import ContentManagementContext, { ContentType } from '../../ContentManagementProvider/Context'
import { CONTENT_TYPES } from '@scoir/college-content'

const NewContentMenuButton = () => {
  const { handleFocusedItemType } = useContext(ContentManagementContext)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleTypeClick = (type?: ContentType) => {
    handleFocusedItemType(type)
    handleClose()
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        size="large"
        endIcon={<FontAwesomeIcon icon={faCaretDown} />}
        onClick={handleClick}
      >
        New Content
      </Button>
      <Menu
        getContentAnchorEl={null}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <MenuItem onClick={() => handleTypeClick()}>Post</MenuItem>
        <MenuItem onClick={() => handleTypeClick(CONTENT_TYPES.SESSIONS as ContentType)}>Event</MenuItem>
        <MenuItem onClick={() => handleTypeClick(CONTENT_TYPES.PROGRAMS as ContentType)}>Program</MenuItem>
      </Menu>
    </>
  )
}

export default NewContentMenuButton
